import { render, staticRenderFns } from "./NewsSingle.vue?vue&type=template&id=19f3d04a&"
import script from "./NewsSingle.vue?vue&type=script&lang=js&"
export * from "./NewsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports